import { Injectable, OnDestroy } from '@angular/core'
import { Country, GlobalMessageService, GlobalMessageType, UserIdService, } from '@spartacus/core'
import { Store } from '@ngrx/store'
import { MbCartActions } from '../store/actions'
import { MbCartMigrationFacade } from '../facades/mb-cart-migration.facade'
import { Subscription } from 'rxjs'
import { MbConstants } from '../../shared/mb-constants'
import { CountryLanguageService } from '../../site-context/facade/country-language.service'
import { CountryService } from '../../site-context/facade/country.service'
import { MbCartMigrationContext } from '../../models'
import { StateWithMultiCart } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root'
})
export class MbCartMigrationService implements MbCartMigrationFacade, OnDestroy {

  subscription = new Subscription()
  userId: string | undefined
  cartId: string | undefined
  constants = MbConstants
  activeSiteCountryIso: string | undefined

  constructor (protected cartStore: Store<StateWithMultiCart>,
               protected userIdService: UserIdService,
               protected globalMessageService: GlobalMessageService,
               protected countryLanguageService: CountryLanguageService,
               protected countryService: CountryService) {
    this.subscription.add(this.userIdService.getUserId().subscribe(activeUserId =>
      this.userId = activeUserId))

    this.subscription.add(this.countryService.getActive().subscribe(activeSiteCountryIso =>
      this.activeSiteCountryIso = activeSiteCountryIso))
  }

  migrateCart (cartId: string, selectedCountry?: Country, isLoginProcess: boolean = false) {
    if (cartId) {
      this.cartId = cartId
    }
    if (selectedCountry?.isocode) {
      const cartMigrationInfo = this.getCartMigrationInfo(selectedCountry.isocode, cartId, isLoginProcess)
      if (this.userId && this.cartId && cartMigrationInfo !== null) {
        this.cartStore.dispatch(new MbCartActions.MigrateCart({
          userId: this.userId,
          cartId: this.cartId,
          cartMigrationInfo: cartMigrationInfo,
          isLoginProcess: isLoginProcess
        }))
      } else {
        this.globalMessageService.add({ key: 'quoteInfo.error' }, GlobalMessageType.MSG_TYPE_ERROR)
      }
    }
  }

  getCartMigrationInfo (selectedCountryCode: string, cartId: string, isLoginProcess: boolean) {
    const newBaseSite = this.countryLanguageService.getBaseSiteForCountry(selectedCountryCode)
    const cartMigrationInfo: MbCartMigrationContext = {
      newCountryIsoCode: selectedCountryCode,
      baseSite: !!newBaseSite,
      guid: cartId
    }
    if (this.activeSiteCountryIso
      && (this.activeSiteCountryIso !== this.constants.FALLBACK_COUNTRY || !!newBaseSite)
      && this.activeSiteCountryIso !== selectedCountryCode) {
      return {
        ...cartMigrationInfo,
        willChangeBaseSite: true
      } as MbCartMigrationContext
    } else {
      return {
        ...cartMigrationInfo,
        willChangeBaseSite: false
      } as MbCartMigrationContext
    }
  }

  ngOnDestroy () {
    this.subscription.unsubscribe()
  }
}
